// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".wallet-address[data-v-6eab51d0]{line-height:.8rem}.copy-address[data-v-6eab51d0]{border-left:1px solid #000;line-height:12px}.copy-icon[data-v-6eab51d0]{cursor:pointer;padding-bottom:2px;padding-left:6px}.copy-icon:hover i[data-v-6eab51d0]{color:var(--v-accentPurple-base)}.truncated-address[data-v-6eab51d0]{cursor:pointer}.truncated-address[data-v-6eab51d0]:hover{color:var(--v-accentPurple-base)!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
